/**
 * Method that returns a specific document type from the registration document list
 *
 * @param {array} registrationDocs Registration docs to be matched.
 * @param {number} documentType Document type to be searched.
 * @return {object} Document type object that belongs to the registration.
 */
 export const getRegistrationDoc = (registrationDocs, documentType) => {
    let doc = null;

    if(registrationDocs !== undefined && registrationDocs !== null) {
        for (let i = 0; i < registrationDocs.length; i++) {
            if(registrationDocs[i].documentTypeId === documentType) {
                doc = registrationDocs[i];
                break;
            }
        }
    }

    return doc;
}